import trMessages from '../locales/tr_TR.json';

const TrLang = {
  messages: {
    ...trMessages
  },
  locale: 'tr-TR',
};
export default TrLang;
